import { Component, EventEmitter, Output, Input, SimpleChanges, OnChanges, OnInit } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

@Component({
    selector: 'app-notes-editor',
    templateUrl: './notes-editor.component.html',
    styleUrls: ['./notes-editor.component.scss']
})
export class NotesEditorComponent implements OnChanges, OnInit {
    @Input() previousNotes: string;
    @Input() previousNotesVisible: boolean;
    @Input() newNotes: string;
    @Input() hideTitle: boolean;
    @Input() hidePreviousNotesButton: boolean;
    @Input() allowSave = true;
    @Input() allowUpdate = false;
    @Input() allowNewNotes = true;

    @Output() onNotesPopUpClose = new EventEmitter<boolean>();
    @Output() onNewNotesSave = new EventEmitter<string>();

    disableSave = false;
    showHidePreviousNotesButtonTitle = 'Hide Previous Notes';
    previousNotesOrder = 1;
    newNotesOrder = 2;

    iconClose = IconConstants.CLOSE;
    iconSave = IconConstants.SAVE;
    iconCheck = IconConstants.CHECK_MARK;

    saveButtonTitle: string;
    saveButtonIcon: string;

    ngOnInit() {
        this.saveButtonTitle = this.allowSave ? 'Save' : 'Ok';
        this.saveButtonIcon = this.allowSave ? this.iconSave : this.iconCheck;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.previousNotes && changes.previousNotes && changes.previousNotes.currentValue) {
            this.previousNotes = changes.previousNotes.currentValue;
            this.newNotes = null;
        }

        if (!this.previousNotesVisible && changes.previousNotesVisible && changes.previousNotesVisible.currentValue) {
            this.previousNotesVisible = changes.previousNotesVisible.currentValue;
        }
    }

    onCloseClick(): void {
        this.clearAllFields();
        this.onNotesPopUpClose.emit(false);
    }

    onHidePreviousClick(): void {
        this.previousNotesVisible = !this.previousNotesVisible;
        if (!this.previousNotesVisible) {
            this.showHidePreviousNotesButtonTitle = 'Show Previous Notes';
        } else {
            this.showHidePreviousNotesButtonTitle = 'Hide Previous Notes';
        }
    }

    onSaveNotes(): void {
        // ANG-2067
        // To address double click issue on save button disabling it then enabling.
        this.disableSave = true;
        this.onNewNotesSave.emit(this.newNotes);
        setTimeout(() => {
            this.disableSave = false;
        }, 1000);
    }

    private clearAllFields(): void {
        this.previousNotes = null;
        this.newNotes = null;
    }
}
